import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {updateCompanyInfo} from "../../../../store/reducers/companyInfoReducer";
import api from "../../../../constants/api";
import LoadingSpinner from "../../../common/LoadingSpinner";
import {recaptchaSiteKey} from "../../../../constants";

function CompanyListItemLarge({ company }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const alreadyExistsLink = "/alreadyRegistered";
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async (e) => {
        setIsLoading(true);

        const token = await window.grecaptcha.execute(recaptchaSiteKey, {action: 'find_company'})
        const result = await api.findAgiloftCompany(company.registrationNumber || company.safeNumber, token);

        if (result.errors) {
            setIsLoading(false);
            return;
        }

        if (result.exists) {
            history.push(alreadyExistsLink);
            return;
        }

        setIsLoading(false);

        dispatch(updateCompanyInfo(company));
        history.push('/form');
    };

    return (
        <>
            <div className="company-search_container">
                <div className="listDividerHider"></div>
                <div role="button" onClick={handleClick} className="companyInfo_container">
                    <div>
                        <p>{company.name}</p>
                    </div>
                    <div>
                        <p>{company.registrationNumber}</p>
                    </div>
                    <div>
                        <p className="safeno">{company.safeNumber}</p>
                    </div>
                    <div className="companyAddress">
                        <p>{company.addressConcatenated}</p>
                    </div>
                    <div className="selectButton">
                        <button className="plausible-event-name=Registration+Select+Company" disabled={isLoading}>{isLoading ? <LoadingSpinner light={true} small={true}/> : "Select"}</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CompanyListItemLarge;
